<template>
  <div :class="{'user-info':true}">
    <img class="avatar" :src="user.avatar"  @click="login_out"/>
    <div class="info" v-if="!user.uuid">
      <div :style="textSubColorStyle" class="nickname">未登录</div>
      <div :style="textSubColorStyle" class="tips">已是会员？登录享受会员权益</div>
    </div>

    <div class="info" v-else>
      <div class="nickname">
        <span :style="textSubColorStyle">{{nickname}}</span>
        <!-- <div :class="{'vip_icon':true,'vip_icon_no_vip':user.vip_id === 0}" >
          V{{user.level}}
        </div> -->
        <img
          v-if="user.level>0"
          class="vip-level-icon"
          :src="vip_icon"
        />
      </div>
      <template v-if="user.vip_id > 0">
        <div :style="textSubColorStyle" class="tips" v-if="user.vip_end_time">会员有效期：{{user.vip_end_time}}</div>
      </template>

      <template v-else>
        <div :style="textSubColorStyle"  class="tips">开通会员免费看大片</div>
      </template>

    </div>

    <div v-if="!user.uuid" class="btn" @click="login_out">
      登录

    </div>
    <div v-else-if="!is_app || debug" class="btn" @click="login_out">
      切换账号
    </div>
  </div>
</template>

<script>
  import click_handler from '../../tools/mgtv/click'
  import {login, logout} from '../../tools/mgtv/login'
  import { towebp } from '@/tools/towebp'

  export default {
    name: 'UserInfo',
    data() {
      return {
        is_app:gact.is_app,
        debug: gact.debug
      }
    },
    computed: {
      user() {
        return window.$bus.user
      },
      nickname() {
        return window.$bus.user.nickname
      },
      show_head(){
        return window.gact.show_head
      },
      textMainColorStyle:function(){
        return window.$bus.textMainColorStyle
      },
      textSubColorStyle:function(){
        return window.$bus.textSubColorStyle
      },
      vip_icon() {
        let vip_type = window.$bus.user.is_mpp_svip === 1 ? 3 : window.$bus.user.type;
        const level = window.$bus.user.level;
        let icon = '';
        if (vip_type) {
          icon = towebp(`https://vipcdn.mgtv.com/act/assets/badge/icon/${vip_type}/${level}.png`);
        }
        return icon;
      }
    },
    methods: {
      login_out() {
        //登录登出
        if (!this.user.uuid) {
          click_handler('登录', login);
        } else {
          if (!gact.is_app || gact.debug) {
            click_handler('登出', () => {
              this.$dialog.confirm({
                message: '您已登录，是否退出切换账号?'
              }).then(logout).catch(() => {
                console.log('取消')
              });
            });
          }
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  @import "../../share/mixins.styl"

  .user-info
    display flex
    position relative
    width 7.5rem
    align-items center
    padding .2rem 0

  .info
    width 4.9rem

  .nickname
    margin-bottom .1rem
    display: flex;
    position relative
    font-size 0.28rem
    align-items center
    color #888
    >span
      padding-top .02rem
      max-width 3rem
      ellipsis()
    .vip_icon
      height .32rem
      line-height @height
      margin-left .15rem
      position relative
      background url(https://vipcdn.mgtv.com/upload3/201909/pindao/bg-vip-level-1.png) no-repeat
      background-size 100% 100%
      width .7rem
      color white
      font-size .18rem
      padding-left .32rem
      &::before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 100%;
        margin-top: .03rem;
      }
    .vip_icon_no_vip
      background url(https://vipcdn.mgtv.com/upload3/201909/pindao/bg-vip-level-0.png) no-repeat
      background-size 100% 100%
    span
      font-size 0.28rem
      vertical-align baseline

  .tips
    font-size .22rem
    color #888
    padding-bottom .1rem
    opacity .7

  .avatar
    width: 0.8rem;
    height: @width;
    border-radius: 100%;
    display inline-block
    margin 0 0.2rem

  .btn
    display: inline-block;
    width: 1.2rem;
    height: 0.48rem;
    line-height @height
    border-radius: .38rem;
    font-size: .26rem;
    text-align center
    color white !important
    background  #f5c265 !important

.vip-level-icon {
  width 24px
  height 16px
  margin-left: 5px
  vertical-align  middle
  pointer-events: none
}
</style>
